import { writable } from 'svelte/store';

let sheet = 0;

function createCurSheet(activeCheatsheet) {
	const { subscribe, update} = writable(activeCheatsheet);
	
	function selectSheet(cheatsheet) {
		update(() => cheatsheet);
	}

	return {
		subscribe,
		selectSheet,
	}
}
export const curSheet = createCurSheet(sheet);

